module.exports = __webpack_public_path__ + "img/9791187962809.894c629b.jpg";